(function (html) {
	var OPTION_TAG = '<option value="{val}" {attributes}>{text}</option>';

    //copied from stackoverflow
    //http://stackoverflow.com/questions/1219860/javascript-jquery-html-encoding

    function htmlEncode(value) {
        return value ? $('<div/>').text(value).html() : "";
    }

    function htmlDecode(value) {
        return value ? $('<div/>').html(stripScripts(value)).text() : "";
    }

    function stripScripts(s) {
        var div = document.createElement('div');
        div.innerHTML = s;
        var scripts = div.getElementsByTagName('script');
        var i = scripts.length;
        while (i--) {
            scripts[i].parentNode.removeChild(scripts[i]);
        }
        return div.innerHTML;
    }

    function parseURLsInHtml(text) {

        var URLs = [];
        var exp = /\s(?:href|src)=["|']?(.*?)["|']+/gim;
        text.replace(exp, function () {
            URLs.push(Array.prototype.slice.call(arguments, 0, 1))
        });
        return URLs;
    }

    function executeScript(text) {
        // from http://stackoverflow.com/questions/2592092/executing-script-elements-inserted-with-innerhtml
        var scripts = '';

        if (text.indexOf('</script>') < 0) return text; //does not seem to work unless a script is provided

        var cleaned = text.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, function () {
            scripts += arguments[1] + '\n';
            return '';
        });

        if (window.execScript) {
            window.execScript(scripts);
        } else {
            var head = document.getElementsByTagName('head')[0];
            var scriptElement = document.createElement('script');
            scriptElement.setAttribute('type', 'text/javascript');
            scriptElement.innerText = scripts;
            head.appendChild(scriptElement);
            head.removeChild(scriptElement);
        }
        return cleaned;
    }

	function sortOptionsAlphabetically(jqTarget) {
		var options = $("option[value!='0']", jqTarget);

		var arr = options.map(function (_, o) { return { t: $(o).text(), v: o.value }; }).get();
		arr.sort(function (o1, o2) {
			var t1 = o1.t.toLowerCase(), t2 = o2.t.toLowerCase();
			return t1 > t2 ? 1 : t1 < t2 ? -1 : 0;
		});
		options.each(function (i, o) {
			o.value = arr[i].v;
			$(o).text(arr[i].t);
		});
	}

	function sortListItemsAlphabetically(jqTarget) {
		var listItems = $('li', jqTarget);

		function sortLi(a, b) {
			return $(b).text().toLowerCase() < $(a).text().toLowerCase() ? 1 : -1;
		}

		listItems.sort(sortLi).appendTo(jqTarget);
	}

    function resetOptionsTexts(target, attributes, separator, optionTag, textSelector) {
        optionTag = optionTag ? optionTag : "option";

        $(optionTag, target).each(function () {
            var newText = "";
            for (var i = 0; i < attributes.length; i++) {
                var attr = $(this).attr(attributes[i]);
                if (attr != "undefined" && attr != "") {
                    newText += newText.length > 0 ? separator : "";
                    newText += $(this).attr(attributes[i]);
                }
            }

            if (newText.length > 0)
                if (!textSelector)
                    $(this).text(newText);
                else
                    $(textSelector, this).text(newText);
        });
    }

    /* bind provided items to a <select> element */
    function bindSelect(jqTarget, items, valueField, textField, noSelectionLabel,
        keepSelection, noSelectionValue, hideUnavailableOptions, extraAttributes, append, optGroup) {
        /* store selected items */
        if (keepSelection)
            keepSelection = ($(jqTarget).val() || '').split(',');

        if (!append)
            $(jqTarget).children().remove();
        var allItems = [], noSelItem = {}, markup;
        /* if selection label is specific, add first item with value 0 */
        if (noSelectionLabel) {
            noSelItem[valueField] = noSelectionValue || 0;
            noSelItem[textField] = noSelectionLabel;
            allItems.push(noSelItem);
        }
        var parent = null;
        if (hideUnavailableOptions && this.isHidden) {
            parent = jqTarget.parent().find('.hiddenOptions').first();
        } else {
            parent = $(jqTarget).first();
        }
        allItems = allItems.concat(items);

		var options = [];
		var addedOptGroups = [];
		$(allItems).each(function () {
			var currentGroup = null;
			if (optGroup && this[optGroup.id]) {
				var optGroupId = this[optGroup.id];
				if (addedOptGroups.filter(function (og) { return og.id == optGroupId; }).length == 0) {
					currentGroup = { id: optGroupId, lastOptionIx: options.length };
					addedOptGroups.push(currentGroup);

					options.push('<optgroup label="{ogLabel}">'.replace(/\{ogLabel\}/, this[optGroup.text]));
					options.push('</optgroup>');
				} else
					currentGroup = addedOptGroups.filter(function (og) { return og.id == optGroupId; })[0];
			}

			markup = OPTION_TAG.replace(/\{val\}/, this[valueField]).replace(/\{text\}/, this[textField]).replace(/\{title\}/, this[textField]);
			if (extraAttributes && extraAttributes.length > 0) {
				var attributes = "";
				for (var i = 0; i < extraAttributes.length; i++)
					attributes += extraAttributes[i] + '="' + this[extraAttributes[i]] + '" ';
				markup = markup.replace(/\{attributes\}/, attributes);
			} else {
				markup = markup.replace(/\{attributes\}/, '');
			}

			if (currentGroup) {
				$(addedOptGroups).each(function () {
					if (this.lastOptionIx > currentGroup.lastOptionIx)
						this.lastOptionIx++;
				});
				currentGroup.lastOptionIx++;
				options.splice(currentGroup.lastOptionIx, 0, markup);
			} else
				options.push(markup);
        });

        var scrollPosition = parent.scrollTop();

        parent.append(options.join(""));

        if (append)
            parent.scrollTop(scrollPosition);

        if (keepSelection)
            setSelectedValues(jqTarget, keepSelection);

        if ($(jqTarget).val() === null && !append) {
            if (noSelectionLabel)
                setSelectedValues(jqTarget, noSelectionValue || '0');
            else
                $(jqTarget).find("option:first").attr("selected", true);
        }
    }

    function bindUL(jqTarget, items, valueField, textField, titleField, className, extraAttributes) {
        $(jqTarget).children().remove();

        var allItems = [].concat(items);
        var itemsHtml = allItems.map(function (item) {
            var extraAttrHtml = '';
            if (extraAttributes && extraAttributes.length > 0) {
                for (var i = 0; i < extraAttributes.length; i++)
                    extraAttrHtml += extraAttributes[i] + '="' + item[extraAttributes[i]] + '" ';
            }

            return '<li '+
                ((valueField !== undefined && valueField !== '') ? 'data-value="' + item[valueField] + '" ' : '') +
                ((titleField !== undefined && titleField !== '') ? 'title="' + item[titleField] + '" ' : '') +
                 ((className !== undefined && className !== '') ? 'class="' + className + '" ' : '') +
                extraAttrHtml +
                '><i class="DUI-icon DUI-icon-move"></i><span>' + item[textField] + '</span></li>';
       });

        $(jqTarget).append(itemsHtml.join(''));
    }

    function setSelectedValues(jqTarget, values) {
        var target = jqTarget instanceof jQuery ? jqTarget : $(jqTarget);
        var items = [].concat(values);
        $.each(target, function () { $(this).val(items); });
    }

    function setSelectedValuesOrFirst(jqTarget, values) {
        setSelectedValues(jqTarget, values);

        if ($(jqTarget).val() === null)
            $(jqTarget).find("> option:first").attr("selected", true);
	}

    /* returns an object with all attributes of the selected item of the <select> element */
    function getSelectValue(jqTarget) {
        var obj = {};
        if ($(jqTarget).val() !== null) {
            var selOption = $('option[value=' + $(jqTarget).val() + ']')[0];
            var i = 0, attrs = selOption.attributes;
            for (; i < attrs.length; i++)
                obj[attrs[i].name] = attrs[i].value;
        }
        return obj;
    }

	function setBitFlags(checkboxClass, bitmask) {
		$(checkboxClass + "[type='checkbox']").each(function () {
			var val = parseInt($(this).val() || 0, 10);
			$(this).attr("checked", (val & bitmask) == val);
		});
	}

	function getBitFlags(checkboxClass) {
		var val = 0;
		$(checkboxClass + "[type='checkbox']:enabled").each(function () {
			if ($(this).is(":checked"))
				val += parseInt($(this).val() || 0, 10);
		});
		return val;
	}

    function copyEnabledOptions(sourceControl, targetControl, enableAll, options, selectionToRestore, selectFirst) {
        if (enableAll)
            $(targetControl).append($(sourceControl + " option").clone());
        else if (options.length > 0) // keep options order
            $(sourceControl + " option").each(function () {
                var optId = $(this).val();

                if (optId == "0") {
                    $(targetControl).append($(sourceControl + " option[value='0']").clone());
                    return;
                }

                $.map(options, function (rsId) {
                    if (optId == rsId)
                        $(targetControl).append($(sourceControl + " option[value='" + optId + "']").clone());
                });
            });
        HTMLHelpers.setSelectedValues(targetControl, selectionToRestore);
        if (selectFirst && $(targetControl + " option:selected").length < 1)
            $(targetControl + " option:first").attr("selected", "selected");
        $(targetControl).filter('.ui-multiselect-element').multiselect("refresh");
	}

	function isCloseToWhite(color) {
		var r, g, b, hsp;

		// Check the format of the color, HEX or RGB?
		if (color.match(/^rgb/)) {
			// If HEX --> store the red, green, blue values in separate variables
			color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

			r = color[1];
			g = color[2];
			b = color[3];
		}
		else {
			// If RGB --> Convert it to HEX: http://gist.github.com/983661
			color = +("0x" + color.slice(1).replace(
				color.length < 5 && /./g, '$&$&'
			));

			r = color >> 16;
			g = color >> 8 & 255;
			b = color & 255;
		}

		// HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
		hsp = Math.sqrt(
			0.299 * (r * r) +
			0.587 * (g * g) +
			0.114 * (b * b)
		);

		// Using the HSP value we can determine whether the color is light or dark
		return hsp > 240;
	}

	function shadeBlend(p, c0, c1) {
		var n = p < 0 ? p * -1 : p, u = Math.round, w = parseInt;
        var f, t, R, G, R1, G1, B, B1;
		if (c0.length > 7) {
			f = c0.split(","), t = (c1 ? c1 : p < 0 ? "rgb(0,0,0)" : "rgb(255,255,255)").split(","), R = w(f[0].slice(4)), G = w(f[1]), B = w(f[2]);
			return "rgb(" + (u((w(t[0].slice(4)) - R) * n) + R) + "," + (u((w(t[1]) - G) * n) + G) + "," + (u((w(t[2]) - B) * n) + B) + ")"
		} else {
			f = w(c0.slice(1), 16), t = w((c1 ? c1 : p < 0 ? "#000000" : "#FFFFFF").slice(1), 16), R1 = f >> 16, G1 = f >> 8 & 0x00FF, B1 = f & 0x0000FF;
			return "#" + (0x1000000 + (u(((t >> 16) - R1) * n) + R1) * 0x10000 + (u(((t >> 8 & 0x00FF) - G1) * n) + G1) * 0x100 + (u(((t & 0x0000FF) - B1) * n) + B1)).toString(16).slice(1)
		}
	}

	function getPointHoverColor(originalColor, scale) {
		scale = scale || 1;
		var isCloseToWhite = HTMLHelpers.isCloseToWhite(originalColor);		
		return HTMLHelpers.shadeBlend((isCloseToWhite ? -0.075 : 0.2) * scale, originalColor);
	}

	function getChildComments(parentElement, selector) {
		if (parentElement instanceof jQuery) parentElement = parentElement[0];
		if (!parentElement) return;

		let comments = [];

		if (parentElement.childNodes) {
			comments = Array.from(parentElement.childNodes).filter(function(node) {
					return node.nodeType === Node.COMMENT_NODE;
				});
		}

		if (selector) {
			return comments.filter(function(comment) {
				return $(comment.textContent).is(selector);
			});
		}

		return comments;
	}

	function optionToComment(jqTarget) {
		const target = jqTarget instanceof jQuery ? jqTarget : $(jqTarget);
		const comments = [];
		target.each(function(_i, element) {
			const comment = document.createComment(element.outerHTML);
			element.parentNode.replaceChild(comment, element);
			comments.push(comment);
		});
		return comments;
	}

	function commentToOption(jqTarget) {
		const target = jqTarget instanceof jQuery ? jqTarget : $(jqTarget);
		const restoredElements = [];
		target.each(function(_i, element) {
			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = element.textContent.trim();
			const restoredElement = tempDiv.firstElementChild;
			element.parentNode.replaceChild(restoredElement, element);
			restoredElements.push(restoredElement);
		});
		return restoredElements;
	}

    html.htmlEncode = htmlEncode;
    html.htmlDecode = htmlDecode;
    html.parseURLsInHtml = parseURLsInHtml;
    html.executeScript = executeScript;
    html.bindSelect = bindSelect;
    html.bindUL = bindUL;
    html.getSelectValue = getSelectValue;
    html.setSelectedValues = setSelectedValues;
    html.setSelectedValuesOrFirst = setSelectedValuesOrFirst;
    html.setBitFlags = setBitFlags;
    html.getBitFlags = getBitFlags;
    html.sortOptionsAlphabetically = sortOptionsAlphabetically;
    html.sortListItemsAlphabetically = sortListItemsAlphabetically;
    html.resetOptionsTexts = resetOptionsTexts;
	html.copyEnabledOptions = copyEnabledOptions;
	html.isCloseToWhite = isCloseToWhite;
	html.getPointHoverColor = getPointHoverColor;
	html.shadeBlend = shadeBlend;
	html.getChildComments = getChildComments;
	html.optionToComment = optionToComment;
	html.commentToOption = commentToOption;

})(window.HTMLHelpers = (window.HTMLHelpers || {}));